export default "__VITE_ASSET__Bt3wxqYN__"